import React from "react";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import { kpiReport, buttonName } from "../../locales/en";
import CommonModal from "./CommonModal";
import { REF_COLUMNS } from "../table/all-tables/reportable/monthlykpireport/modaltabel/customer/columns";
import { REFERRAL_PARTNER_EDIT_WITH_ID } from "../../route/paths";
import MonthlyKpiReportCustomerTable from "../table/all-tables/reportable/monthlykpireport/modaltabel/customer/MonthlyKpiReportCustomerTable";
import { FULLNAME, REFERRALDETAILS } from "../../utils/constants/appConstants";

const MonthlyKpiReportReferralModal = ({
  isOpen,
  toggle,
  invoiceIdsListRef,
  filterType
}) => {
  const footerButtons = [
    {
      label: buttonName?.close,
      className: "btn btn-secondary",
      onClick: () => toggle(false)
    }
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={kpiReport?.referralModal?.title}
      modalClassName="modal-lg modal-dialog-scrollable"
      bodyClassName={Modalstyle.refMonthlySingleContent}
      footerButtons={footerButtons}
    >
      <MonthlyKpiReportCustomerTable
        invoiceIdsListRef={invoiceIdsListRef}
        columnsConfig={REF_COLUMNS}
        detailsKey={REFERRALDETAILS}
        linkColumnId={FULLNAME}
        buildLink={(id) => REFERRAL_PARTNER_EDIT_WITH_ID(id)}
        filterType={filterType}
      />
    </CommonModal>
  );
};
MonthlyKpiReportReferralModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  invoiceIdsListRef: PropTypes.object,
  filterType: PropTypes.string
};

export default MonthlyKpiReportReferralModal;
